module.exports = __webpack_public_path__ + "static/media/Image-3.127f2bf4.png";